import React from 'react';
const SvgExtractFailureThumbnail = React.forwardRef((rest, ref) => {
  const props = { ...rest, ref };
  return (
    <svg width="1em" height="1em" viewBox="0 0 142 122" {...props}>
      <path
        d="M82.77 122h58.955V39.783h-16.013v55.695H107.03v9.283h-4.004V86.196h4.004V91.5h14.678V39.783h-20.016V25.196H75.188l-3.448 9.213 16.08 32.226-9.802 21.484L82.771 122zm-4.532 0H.275V0h53.711l-2.3 21.217H16.288v74.261h46.476L78.238 122zM84.617 0h17.075v21.217H76.676L84.616 0zM60.443 91.5H20.292V61h10.675v-3.978H20.292V25.196h30.963l-.999 9.213L62.8 57.022h-7.813V61h10.02l3.126 5.635-9.663 21.484 1.973 3.381zM105.695 0l36.03 35.804h-36.03V0z"
        fill="#E4E4E3"
        fillRule="evenodd"
      />
    </svg>
  );
});
export default SvgExtractFailureThumbnail;
SvgExtractFailureThumbnail.iconName = 'extract-failure-thumbnail';
SvgExtractFailureThumbnail.displayName = 'SvgExtractFailureThumbnail';
